<template>
  <v-dialog v-model="dialogApprove" persistent max-width="688px" :retain-focus="false">
      <v-card tile class="pt-4 pl-10 pr-10 pb-4">
        <v-divider
            inset
            vertical
          ></v-divider>
        <div class="">
          <span class="black--text font-weight-bold mr-5">ข้อมูลการอนุมัติ</span>
          <v-chip
            v-if="dataRequestDoc.requestStatus=='pending'"
            small
            :color="dataRequestDoc.requestStatusTH=='กำลังดำเนินการ'? '#ECF9FF':'#FEF5E9'"
            :text-color="dataRequestDoc.requestStatusTH=='กำลังดำเนินการ'? '#00B0FF':'#E9A016'"
          >
            <span>{{ dataRequestDoc.requestStatusTH }}</span>
          </v-chip>
          <v-chip
            v-else-if="dataRequestDoc.requestStatus=='waiting'"
            small
            :color="'#FEF5E9'"
            text-color="#E9A016"
          >
            <span>รออนุมัติ</span>
          </v-chip>
          <v-chip
            v-else-if="dataRequestDoc.requestStatus=='approve'"
            small
            :color="'#ECF8EA'"
            text-color="#58A144"
          >
            <span>อนุมัติแล้ว</span>
          </v-chip>
          <v-chip
            v-else-if="dataRequestDoc.requestStatus=='acknowledge'"
            small
            :color="'#ECF8EA'"
            text-color="#58A144"
          >
            <span>รับทราบแล้ว</span>
          </v-chip>
          <v-chip
            v-else
            small
            :color="'#FBE5E4'"
            text-color="#D1392B"
          >
            <span>ไม่อนุมัติ</span>
          </v-chip>
          <v-btn absolute right top icon x-small @click="closeDialogApprove"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-divider class="mt-4 mb-4"/>
        <v-row class="mt-0" style="">
          <v-col cols="12" lg="5" md="6" sm="6">
            <pre class="ra-head-text-gray">หมายเลขคำร้อง</pre>
            <pre class="ra-head-text black--text">{{ dataRequestDoc.reqOrgChartNo }}</pre>
          </v-col>
          <v-col cols="12" lg="7" md="6" sm="6">
            <pre class="ra-head-text-gray">ประเภทคำร้อง</pre>
            <pre class="ra-head-text black--text">{{ dataRequestDoc.requestTypeTH }}</pre>
          </v-col>
          <v-col cols="12" lg="12" md="12" sm="12">
            <pre class="ra-head-text-gray">รายละเอียด</pre>
            <pre class="ra-head-text black--text  text-wrap">{{ dataRequestDoc.requestDetailTH }}</pre>
          </v-col>
        </v-row>
        <v-row class="mt-0" style="">
          <v-col cols="12" lg="5" md="6" sm="6">
            <pre class="ra-head-text-gray">สายบังคับบัญชาต้นทาง</pre>
            <pre class="ra-head-text black--text">{{ dataRequestDoc.beforeOrgChartName || '-' }}</pre>
          </v-col>
          <v-col cols="12" lg="7" md="6" sm="6">
            <pre class="ra-head-text-gray">สายบังคับบัญชาปลายทาง</pre>
            <pre class="ra-head-text black--text">{{ dataRequestDoc.afterOrgChartName || '-' }}</pre>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <pre class="ra-head-text black--text font-weight-bold">ลำดับการอนุมัติ</pre>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-timeline
              class="user-data-panel"
              style="margin-top: -14px;"
              align-top
              dense
            >
              <v-timeline-item
                v-for="item in dataRequestDoc.approveBy"
                :key="item.no"
                :color="item.statusApprove=='waiting' ? '#E0EAFB':'#3776E9'"
                small
                fill-dot
              >
                <template v-slot:icon>
                  <span :class="item.statusApprove=='waiting' ? 'blue--text':'white--text'">
                    {{ dataRequestDoc.approveBy.indexOf(item)+1 }}
                  </span>
                </template>
                <v-row style="margin-top: -12px;">
                  <v-col cols="12" lg="6" md="6" sm="6">
                    <pre class="ra-head-text font-weight-black">{{ item.approverName }}</pre>
                    <pre class="ra-head-text-gray">{{ item.email }}</pre>
                    <pre class="ra-head-text-gray">{{ item.positonName }}</pre>
                    <pre v-if="item.comment" class="ra-head-text black--text text-wrap" style="width: calc(100% + 0px);">ความเห็น : {{ item.comment }}</pre>
                    <pre v-else class="ra-head-text black--text"></pre>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6">
                    <v-row class="ml-0">
                    <v-chip
                      v-if="item.statusApprove=='pending'"
                      small
                      :color="item.statusApproveTh=='กำลังดำเนินการ'? '#ECF9FF':'#FEF5E9'"
                      :text-color="item.statusApproveTh=='กำลังดำเนินการ'? '#00B0FF':'#E9A016'"
                    >
                      <span>{{ item.statusApproveTh }}</span>
                    </v-chip>
                    <!-- <v-chip
                      v-else-if="item.statusApprove=='waiting'"
                      small
                      :color="'#FEF5E9'"
                      text-color="#E9A016"
                    >
                      <span>รออนุมัติ</span>
                    </v-chip> -->
                    <v-chip
                      v-else-if="item.statusApprove=='approve'"
                      small
                      :color="'#ECF8EA'"
                      text-color="#58A144"
                    >
                      <span>{{ item.approveByAdmin? 'อนุมัติโดย แอดมิน':'อนุมัติแล้ว' }}</span>
                    </v-chip>
                    <v-chip
                      v-else-if="item.statusApprove=='reject'"
                      small
                      :color="'#FBE5E4'"
                      text-color="#D1392B"
                    >
                      <span>{{ item.approveByAdmin? 'ไม่อนุมัติโดย แอดมิน':'ไม่อนุมัติ' }}</span>
                    </v-chip>
                    </v-row>
                    <v-row class="mt-4 ml-0" style="padding-left: 5px;">
                    <p class="ra-head-text-gray">
                      {{ item.approveDate? initDate(item.approveDate):''}}
                    </p>
                    </v-row>
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
          </v-col>
        </v-row>
        <v-row class="mt-0 mb-0" style="" v-if="dataRequestDoc.requestStatusTH == 'รออนุมัติ'">
          <v-col cols="12">
            <pre class="ra-head-text-gray mb-0">อนุมัติคำร้อง</pre>
            <v-radio-group
              v-model="comfirmAction"
              row
              style="margin-top: 5px;"
            >
              <v-radio
                class="border-black-box pa-1"
                style="width: 120px; font-family: 'Sarabun', sans-serif; font-size: 12px;"
                label="อนุมัติ"
                color="#2BA197"
                value="approve"
              ></v-radio>
              <v-radio
                class="border-black-box pa-1"
                style="width: 120px; font-family: 'Sarabun', sans-serif; font-size: 12px;"
                label="ไม่อนุมัติ"
                color="#2BA197"
                value="reject"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row class="mt-0 mb-2" style="" v-if="dataRequestDoc.requestStatusTH == 'รออนุมัติ'">
          <v-textarea
            v-model="confirmNote"
            outlined
            label=""
            placeholder="ระบุความเห็น"
            class="pl-3 pr-3"
            style="margin-top: -10px;"
            height="50"
            @keydown.space="preventLeadingSpace"
          ></v-textarea>
        </v-row>
        <v-card-actions class="justify-center">
          <v-btn elevation="0" width="70" class="button-color-outline" outlined @click="closeDialogApprove" v-if="dataRequestDoc.requestStatusTH !== 'รออนุมัติ'">ปิด</v-btn>
          <v-btn elevation="0" width="70" class="button-color-outline mr-4" outlined @click="closeDialogApprove" v-else>ยกเลิก</v-btn>
          <v-btn elevation="0" width="70" class="button-color head-search-button ml-1 white--text text--lighten-4" @click="pressConfrim" :disabled="!comfirmAction" v-if="dataRequestDoc.requestStatusTH == 'รออนุมัติ'">ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
      <!-- <DialogTransferPermission/> -->
    </v-dialog>
</template>

<script>
import { EventBus } from '@/EventBus'
import { getDetailStructureReq, updateStatusStructureReq } from '@/API/API'
import swal from 'sweetalert'
import moment from 'moment'

export default {
  components: {
  },
  data () {
    return {
      mode: '',
      dialogApprove: false,
      id: '',
      reqEmployeeNo: '',
      requestType: '',
      detail: '',
      employeeName: '',
      accountId: '',
      employeeId: '',
      employeeTitle: '',
      positionName: '',
      userImg: '',
      orgChartId: '',
      lineofwork: '',
      statusForApprove: '',
      status: '',
      management: '',
      section: '',
      department: '',
      agency: '',
      groupwork: '',
      email: '',
      approveBy: [],
      dataSource: [],
      filterData: {},
      server: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}`,
      textCondition: {
        new: 'เพิ่มบุคคลเข้าทำงานในตำแหน่งงานใหม่',
        transfer: 'ขอย้ายฝ่ายเข้าทำงานในตำแหน่งงานใหม่',
        resign: 'ขอลาออก',
        transferPosition: 'ขอย้ายตำแหน่ง',
        resignPosition: 'ขอลาออกจากตำแหน่ง',
        resignEmployee: 'ลาออกจากบริษัท'
      },
      statusList: [
        { status: 'pending', statusTH: 'กำลังดำเนินการ', color: '#00B0FF' },
        { status: 'approve', statusTH: 'อนุมัติแล้ว', color: '#58A144' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#D1392B' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144' }
      ],
      dataRequestDoc: {},
      userID: this.$store.state.user._id,
      userRole: localStorage.approveRole,
      comfirmAction: '',
      confirmNote: ''
    }
  },
  computed: {
    statusShow: function () {
      var filterStatus = this.status.filter(e => e.approverStatus === 'cancel')
      return filterStatus.length > 0 ? [filterStatus[0]] : this.status
    }
  },
  mounted () {
    EventBus.$on('openDialogManageStructureApprove', this.getDetailRequest)
  },
  beforeDestroy () {
    EventBus.$off('openDialogManageStructureApprove')
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsEmpId = this.$route.params.id
    this.dataSource = []
  },
  methods: {
    // ป้องกันการกรอก Spacebar
    preventLeadingSpace (e) {
      // ป้องกันการกด spacebar ถ้ายังไม่มีการกรอกข้อมูล
      if (!e.target.value) e.preventDefault()
      // ถ้าหากอักขระนำหน้าเป็นช่องว่าง ให้ลบช่องว่างนำหน้าทั้งหมดออก
      else if (e.target.value[0] === ' ') e.target.value = e.target.value.replace(/^\s*/, '')
    },
    closeDialogApprove () {
      this.dialogApprove = false
    },
    initDate (date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    },
    async getDetailRequest (role, item) {
      this.comfirmAction = ''
      this.confirmNote = ''
      const token = this.$store.state.token
      try {
        const res = await getDetailStructureReq({ requestId: item._id, role: (localStorage.approveRole || 'User') }, token)
        if (res.success) {
          if (res.result) {
            this.dataRequestDoc = res.result
            this.dialogApprove = true
          }
        }
      } catch (error) {
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
      } finally {
        this.loading = true
      }
    },
    async pressConfrim () {
      const token = this.$store.state.token
      var payload = {
        role: localStorage.approveRole,
        approveList: [
          {
            requestStatus: this.comfirmAction,
            _id: this.dataRequestDoc._id,
            comment: this.confirmNote
          }
        ]
      }
      try {
        const res = await updateStatusStructureReq(payload, token)
        if (res.success) {
          if (res.result) {
            this.filterData = {
              role: localStorage.approveRole
            }
            this.closeDialogApprove()
            EventBus.$emit('manageStructureApproveSearch', this.filterData)
          }
        }
      } catch (error) {
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
      } finally {
        this.loading = true
      }
    }
  }
}
</script>
<style >

.v-timeline::before {
    top: 24px;
    height: calc(100% - 125px)
}

.v-label {
  font-family: 'Sarabun', sans-serif;
  font-size: 14px;
  line-height: 1;
  min-height: 8px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>
